import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=77b01f91&scoped=true&"
import script from "./GroupDetail.vue?vue&type=script&lang=js&"
export * from "./GroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupDetail.vue?vue&type=style&index=0&id=77b01f91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b01f91",
  null
  
)

export default component.exports